module.exports = __webpack_public_path__ + "static/media/pic2.16ba24c7.jpg";